__turbopack_context__.v({
  "bar_container": "styles-module-scss-module__d1BgNa__bar_container",
  "bar_fill": "styles-module-scss-module__d1BgNa__bar_fill",
  "bar_handle": "styles-module-scss-module__d1BgNa__bar_handle",
  "bar_percentage": "styles-module-scss-module__d1BgNa__bar_percentage",
  "bar_status": "styles-module-scss-module__d1BgNa__bar_status",
  "bar_track": "styles-module-scss-module__d1BgNa__bar_track",
  "bar_values": "styles-module-scss-module__d1BgNa__bar_values",
  "center_label": "styles-module-scss-module__d1BgNa__center_label",
  "center_value": "styles-module-scss-module__d1BgNa__center_value",
  "condensed": "styles-module-scss-module__d1BgNa__condensed",
  "container": "styles-module-scss-module__d1BgNa__container",
  "info_icon": "styles-module-scss-module__d1BgNa__info_icon",
  "instruction_text": "styles-module-scss-module__d1BgNa__instruction_text",
  "label_with_tooltip": "styles-module-scss-module__d1BgNa__label_with_tooltip",
  "legend_wrapper": "styles-module-scss-module__d1BgNa__legend_wrapper",
  "status_indicator": "styles-module-scss-module__d1BgNa__status_indicator",
  "track": "styles-module-scss-module__d1BgNa__track",
});
